<template>
  <div class="user">
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="this.$store.state.employee.employees.data"
        :search="search"
        hide-default-footer
        :loading="this.$store.state.categories.isLoading"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.name`]="item">
          {{ item.item.first_name + " " + item.item.last_name }}
        </template>
        <template v-slot:[`item.position`]="item">
          {{ getEmployeePositionLan(item.item.position) }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip
            class="ma-2"
            :color="getStatusColor(item.item.status)"
            text-color="white"
            small
          >
            {{ getStatusLan(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click="show(item.item.id)"
                class="px-1"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>VER</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                @click="edit(item.item)"
                class="px-1"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="item.item.status == 'ACTIVE' ? 'red' : 'success'"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus(item.item)"
              >
                {{
                  item.item.status == "ACTIVE"
                    ? "mdi-lock"
                    : "mdi-lock-open-variant"
                }}
              </v-icon>
            </template>
            <span>
              {{ item.item.status == "ACTIVE" ? "INACTIVAR" : "ACTIVAR" }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red darken-2"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="confirmDelete(item.item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>ELIMINAR</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <!-- Button active dialog -->
    <v-btn
      class="mx-2"
      fab
      dark
      bottom
      absolute
      right
      color="secondary"
      @click="open"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>

    <!-- Create or edit dialog -->
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ currentEmployee ? "Editar" : "Crear" }} empleado
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="py-4">
          <v-form ref="formEmployee" v-model="validForm" lazy-validation>
            <v-text-field
              v-model="model.first_name"
              :rules="rules.required"
              label="Nombres"
            ></v-text-field>

            <v-text-field
              v-model="model.last_name"
              :rules="rules.required"
              label="Apellidos"
            ></v-text-field>

            <v-text-field
              v-model="model.id_type"
              :rules="rules.required"
              label="Tipo de documento"
            ></v-text-field>

            <v-text-field
              v-model="model.number_id"
              :rules="rules.required"
              label="# Documento"
            ></v-text-field>

            <v-text-field
              v-model="model.phone"
              :rules="rules.required"
              label="Telefono"
            ></v-text-field>

            <v-text-field v-model="model.email" label="Correo"></v-text-field>

            <v-text-field
              v-model="model.addres"
              :rules="rules.required"
              label="Direccion"
            ></v-text-field>

            <v-autocomplete
              label="Cargo"
              :items="this.$store.state.status.employeePosition"
              v-model="model.position"
              :rules="rules.required"
            ></v-autocomplete>

            <v-select
              :items="offices"
              item-text="name"
              item-value="id"
              label="Seleccione Oficina"
              no-data-text="No hay registros..."
              :rules="rules.required"
              v-model="model.office_id"
            ></v-select>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!validForm"
            color="success"
            class="mr-4"
            small
            @click="save"
          >
            Guardar
          </v-btn>

          <v-btn color="error" text class="mr-4" small @click="clear">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete employee confirmation dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-title class="headline">Eliminar empleado</v-card-title>
        <v-card-text class="py-4" v-if="employeeToDelete">
          ¿Seguro que desea eliminar a
          <b>{{ employeeToDelete.first_name }} {{ employeeToDelete.last_name }}</b>?
          Esta acción no se puede deshacer.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text class="mr-4" @click="dialogDelete = false" small>
            Cancelar
          </v-btn>
          <v-btn color="error" class="mr-4" @click="deleteConfirmation" small text>
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- change status dialog -->
    <v-dialog v-model="dialogChangeStatus" width="500" persistent>
      <v-card>
        <v-card-text class="py-4" v-if="dialogChangeStatus">
          Seguro que desea
          <b>{{
            currentEmployee.status == "ACTIVE" ? "INACTIVAR" : "ACTIVAR"
          }}</b>
          este empleado?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="changeStatusConfirmation"
            small
          >
            Confirmar
          </v-btn>

          <v-btn color="error" text class="mr-4" @click="clear" small>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import { SET_EMPLOYEES } from "@/store/employee";
import { SET_OFFICES } from "@/store/offices";
import { mapGetters } from "vuex";
export default {
  name: "Users",
  data: () => ({
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "start",
        filterable: true,
        value: "name",
      },
      {
        text: "# Documento",
        align: "start",
        filterable: true,
        value: "number_id",
      },
      {
        text: "Telefono",
        align: "start",
        filterable: true,
        value: "phone",
      },
      {
        text: "Cargo",
        align: "start",
        filterable: true,
        value: "position",
      },
      { text: "Estado", value: "status", filterable: false, sortable: false },
      {
        text: "Acciones",
        value: "actions",
        filterable: false,
        sortable: false,
      },
    ],
    pagination: {
      current: 0,
      total: 0,
    },
    dialog: false,
    dialogChangeStatus: false,
    dialogDelete: false,
    employeeToDelete: null,
    validForm: true,
    currentEmployee: null,
    model: {
      first_name: "",
      last_name: "",
      id_type: "",
      number_id: "",
      phone: "",
      email: "",
      addres: "",
      position: "",
      office_id: "",
    },
    rules: {
      required: [(v) => !!v || "EL campo es requerido"],
    },
    offices: [],
  }),
  created() {
    this.$store.dispatch("getEmployees");
    this.$store.dispatch("getOfficesAll");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_EMPLOYEES) {
        this.pagination.current = state.employee.employees.current_page;
        this.pagination.total = state.employee.employees.last_page;
      }
      if (mutation.type === SET_OFFICES) {
        this.offices = state.offices.offices;
      }
    });
  },
  watch: {
    dialog: function () {
      if (this.dialog == false) this.clear();
    },
  },
  computed: {
    ...mapGetters(["getStatusLan", "getStatusColor", "getEmployeePositionLan"]),
  },
  methods: {
    nextPage() {
      this.$store.dispatch("nextPageEmployees", this.pagination.current);
    },
    save() {
      if (!this.$refs.formEmployee.validate()) return;

      if (this.currentEmployee) {
        this.$store.dispatch("updateEmployee", {
          form: this.model,
          id: this.currentEmployee.id,
        });
      } else {
        this.$store.dispatch("createEmployee", this.model);
      }
      this.clear();
    },
    changeStatus(user) {
      this.currentEmployee = user;
      this.dialogChangeStatus = true;
    },
    changeStatusConfirmation() {
      this.$store.dispatch("updateEmployee", {
        form: {
          status:
            this.currentEmployee.status == "ACTIVE" ? "INACTIVE" : "ACTIVE",
        },
        id: this.currentEmployee.id,
      });
      this.clear();
    },
    open() {
      this.dialog = true;
    },
    edit(employee) {
      this.currentEmployee = employee;
      this.model = {
        first_name: employee.first_name,
        last_name: employee.last_name,
        id_type: employee.id_type,
        number_id: employee.number_id,
        phone: employee.phone,
        email: employee.email,
        addres: employee.addres,
        position: employee.position,
        office_id: employee.office_id,
      };
      this.open();
    },
    clear() {
      this.$nextTick(() => {
        if (this.$refs.formEmployee) {
          this.$refs.formEmployee.resetValidation();
        }
      });
      this.model = {
        first_name: "",
        last_name: "",
        id_type: "",
        number_id: "",
        phone: "",
        email: "",
        addres: "",
        position: "",
      };
      this.currentEmployee = null;
      this.dialog = false;
      this.dialogChangeStatus = false;
    },
    confirmDelete(employee) {
      this.employeeToDelete = employee;
      this.dialogDelete = true;
    },
    deleteConfirmation() {
      this.$store.dispatch("deleteEmployee", this.employeeToDelete.id);
      this.dialogDelete = false;
      this.employeeToDelete = null;
    },
    show(id) {
      this.$router.push({ path: `/employees/show/${id}` });
    },
  },
};
</script>
  <style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
  